import { setValue, getValue } from './localStorage';

const TC_ACCEPTED = 'TC_ACCEPTED_';
const REQUESTED_PATH = 'REQUESTED_PATH';
const SIDE_BAR_OPEN_CLOSE = 'SIDE_BAR_OPEN_CLOSE';

export const setUserTcPreference = (userId) => {
  setValue(TC_ACCEPTED + userId, true);
};

export const getUserTcPreference = (userId) => getValue(TC_ACCEPTED + userId);

export const setRequestedPath = (path, searchString = '') => {
  setValue(REQUESTED_PATH, path + searchString);
};

export const getRequestedPath = () => {
  try {
    return getValue(REQUESTED_PATH);
  } catch (e) {
    return '/';
  }
};

export const setSideBarOpenPreference = (open) => {
  setValue(SIDE_BAR_OPEN_CLOSE, open);
};

export const getSideBarOpenPreference = () => getValue(SIDE_BAR_OPEN_CLOSE);
